import { Material, MaterialProperties } from '../../core/Material';
import * as THREE from 'three';

export interface BasicMaterialProperties extends MaterialProperties {
  color: string;
  wireframe: boolean;
}

const properties: BasicMaterialProperties = {
  color: '#ffffff',
  wireframe: false,
};

export const BasicMaterialItem: Material = {
  id: '',
  name: 'Basic Material',
  type: 'material',
  subtype: 'basic',
  properties: properties,
  fields: [
    {
      key: 'properties.color',
      type: 'color',
      label: 'Color',
      default: '#ffffff',
      panel: 'material',
    },
    {
      key: 'properties.wireframe',
      type: 'boolean',
      label: 'Wireframe',
      default: false,
      panel: 'material',
    },
  ],
  render: (props) => {
    const { color, wireframe } = props;
    return new THREE.MeshBasicMaterial({ color, wireframe });
  },
}; 